export let octoberAbbreviatedLowercase = "CA8YA";
export default {octoberAbbreviatedLowercase};